export enum LoginState {
  Email,
  EnterExistingPassword,
  CreateNewPassword,
}
